import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizensUploadableFormRequest} from './citizens-uploadable-form-request.model';
import * as CitizensUploadableFormRequestActions from './citizens-uploadable-form-request.actions';

export const citizensUploadableFormRequestsFeatureKey = 'citizensUploadableFormRequests';

export interface State extends EntityState<CitizensUploadableFormRequest> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensUploadableFormRequest> = createEntityAdapter<CitizensUploadableFormRequest>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensUploadableFormRequestActions.addCitizensUploadableFormRequest,
    (state, action) => adapter.addOne(action.citizensUploadableFormRequest, state)
  ),
  on(CitizensUploadableFormRequestActions.upsertCitizensUploadableFormRequest,
    (state, action) => adapter.upsertOne(action.citizensUploadableFormRequest, state)
  ),
  on(CitizensUploadableFormRequestActions.addCitizensUploadableFormRequests,
    (state, action) => adapter.addMany(action.citizensUploadableFormRequests, state)
  ),
  on(CitizensUploadableFormRequestActions.upsertCitizensUploadableFormRequests,
    (state, action) => adapter.upsertMany(action.citizensUploadableFormRequests, state)
  ),
  on(CitizensUploadableFormRequestActions.updateCitizensUploadableFormRequest,
    (state, action) => adapter.updateOne(action.citizensUploadableFormRequest, state)
  ),
  on(CitizensUploadableFormRequestActions.updateCitizensUploadableFormRequests,
    (state, action) => adapter.updateMany(action.citizensUploadableFormRequests, state)
  ),
  on(CitizensUploadableFormRequestActions.deleteCitizensUploadableFormRequest,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensUploadableFormRequestActions.deleteCitizensUploadableFormRequests,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensUploadableFormRequestActions.loadCitizensUploadableFormRequests,
    (state, action) => adapter.setAll(action.citizensUploadableFormRequests, state)
  ),
  on(CitizensUploadableFormRequestActions.clearCitizensUploadableFormRequests,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
